import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { isAdmin, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0a1425]" data-testid="auth-checking">
        <Loader2 className="h-6 w-6 animate-spin text-amber-500" />
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
};
